import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { SaturationBox } from "./components/SaturationBox.js";
import { SaturationCursor } from "./components/SaturationCursor.js";
const Saturation = forwardRef(function Saturation2(props, ref) {
  const { cursor, ...rest } = props;
  return /* @__PURE__ */ jsx(SaturationBox, { ...rest, ref, testId: "TidalColorPickerSaturation", children: /* @__PURE__ */ jsx(SaturationCursor, { "data-testid": "TidalColorPickerSaturationCursor", style: { ...cursor } }) });
});
export {
  Saturation
};
//# sourceMappingURL=Saturation.js.map
